import styled, { keyframes } from 'styled-components';
import { mediaSizes } from 'src/theme';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const Container = styled.div`
  align-items: center;
  background-color: var(--dcm-color-surface);
  border-bottom: 1px solid var(--dcm-skeleton-border-color);
  display: flex;
  height: var(--dcm-storefront-header-height);
  top: 0;
  width: 100%;
  z-index: var(--dcm-header-z-index);

  @media (max-width: ${mediaSizes.largePhone}px) {
    padding: var(--dcm-storefront-header-padding-mobile);
  }
`;

export const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: var(--dct--customized-maxSiteWidth);
  width: 100%;
`;

export const SkeletonLogo = styled.div`
  animation: ${shimmer} var(--dcm-skeleton-animation-duration) ease-in-out infinite;
  background: linear-gradient(
    90deg,
    var(--dcm-skeleton-shimmer-from) 0px,
    var(--dcm-skeleton-shimmer-to) 40px,
    var(--dcm-skeleton-shimmer-from) 80px
  );
  background-size: 200px 100%;
  border-radius: var(--dcm-skeleton-border-radius);
  height: var(--dcm-skeleton-logo-height);
  margin-left: 2px;
  width: var(--dcm-skeleton-logo-width);
`;

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--dcm-space-3);
`;

export const SkeletonLink = styled.div`
  animation: ${shimmer} var(--dcm-skeleton-animation-duration) ease-in-out infinite;
  background: linear-gradient(
    90deg,
    var(--dcm-skeleton-shimmer-from) 0px,
    var(--dcm-skeleton-shimmer-to) 40px,
    var(--dcm-skeleton-shimmer-from) 80px
  );
  background-size: 200px 100%;
  border-radius: var(--dcm-skeleton-border-radius);
  height: var(--dcm-skeleton-nav-height);
  width: 80px;
`;
